import Layout from "../components/Layout/Layout";
import GarageContent from "../components/GarageContent/GarageContent";

// Saved dealer-stock cars, inquiries, inspections, purchases and billing. The
// same records are shown on the marketing site's /my-garage page - both read
// the auction API.
const Garage = () => {
    return (
        <Layout>
            <GarageContent />
        </Layout>
    );
};

export default Garage;
